<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <head-com
      v-if="pathList.indexOf(path.replace(new RegExp('/', 'g'), '')) == -1"
    ></head-com>
    <router-view v-if="isRouterAlive"></router-view>
    <el-backtop> </el-backtop>
    <foot-com
      v-if="pathList.indexOf(path.replace(new RegExp('/', 'g'), '')) == -1"
    ></foot-com>
  </div>
</template>

<script>
import headCom from "./common/headCom";
import footCom from "./common/footCom";
export default {
  name: "App",
  components: {
    headCom,
    footCom
  },
  data() {
    return {
      ip:'',
      path: "",
      pathList: [
        "login",
        "register",
        "retrieve",
        "mobile_phone",
        "corporate_detail",
        "corporate_supply_all",
        "corporate_demand",
        "corporate_introduce",
        "corporate_list_all",
        "corporate_case_all",
        "corporate_qualifications",
        "supply_detail",
        "alipay_dialog"
      ],
      isRouterAlive:true
    };
  },
  provide(){
    return{ //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
       reload: this.reload     
    }
  }, 
  created(){
    console.log('APP执行')
     this.$store.dispatch("industry/getIndustry");
     this.$store.dispatch("industry/getComanyIndustry");
	 
	 document.getElementById('loading').style.display= "none";
  },
  methods:{
    reload(){
       this.isRouterAlive = false; //先关闭，
       this.$nextTick(function(){
         this.isRouterAlive = true;//再打开
       })
    } 
  },
  mounted() {
    this.path = this.$route.path; //this.path = 当前路由
  },
  destroyed() {
    this.$store.dispatch("user/logout");
  },
  watch: {
    $route(to, from) {
      //监听路由变化
      this.path = to.path; //打开新的页面路由
    },
  },
};
</script>

<style lang="less">
body,
html {
  background-image: none !important;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  min-width: 1300px;
}
.warp {
  width: 1080px;
  margin: 0 auto;
  // @media (min-width: 1600px) {
  //   width: 60%;
  // }
}
/*滚动条样式*/
::-webkit-scrollbar {
  width: 10px;
  /*height: 4px;*/
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

</style>



// WEBPACK FOOTER //
// src/App.vue